const service = () =>
    import('./service/index.vue');
const knowledge = () =>
    import('./knowledge/index.vue');
const commonProblem = () =>
    import('./common-problem/index.vue');
const overChat = () =>
    import('./over-chat/index.vue');

export default [
    // 客服
    {
        path: "/",
        name: "service",
        components: {
            default: service,
        },
        meta: {
            nav: "service",
            navChild: "",
            navName:"接待中",
            keepAlive: true
        },
    },
    {
        path: "/service/overChat",
        name: "overChat",
        components: {
            default: overChat,
        },
        meta: {
            nav: "service",
            navChild: "overChat",
            navName:"已接待",
            keepAlive: true
        },
    },
    {
        path: "/service/knowledge",
        name: "knowledge",
        components: {
            default: knowledge,
        },
        meta: {
            nav: "service",
            navChild: "knowledge",
            navName:"知识库",
            keepAlive: true
        },
    },
    {
        path: "/service/commonProblem",
        name: "commonProblem",
        components: {
            default: commonProblem,
        },
        meta: {
            nav: "service",
            navChild: "commonProblem",
            navName:"常见问题",
            keepAlive: true
        },
    },
]



// WEBPACK FOOTER //
// ./src/views/service/index.js